module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4naI4"))).then(() => parcelRequire('1iHdE'));